import * as t from './actionTypes';
import { WebPushReducerState } from './types';

const initialState = {
  webPushIntegrations: [],
  isLoading: false,
};

const webPushReducer = (
  state: WebPushReducerState['integrations']['webPushIntegrations'] = initialState,
  action: { type?: string; error?: string; response?: any } = {},
) => {
  switch (action.type) {
    case t.FETCH_WEB_PUSH_RESPONSE: {
      return {
        ...state,
        webPushIntegrations: action.response,
        isLoading: false,
      };
    }
    case t.FETCH_WEB_PUSH_REQUEST: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case t.FETCH_WEB_PUSH_ERROR: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case t.CREATE_WEB_PUSH_RESPONSE: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case t.DELETE_WEB_PUSH_RESPONSE: {
      return {
        ...state,
        isLoading: true,
      };
    }
    default: {
      return state;
    }
  }
};

export default webPushReducer;
